import React from 'react'

const LoadingBook = () => (
  <div className="journalCardLoading loadingBook">
    <div className="animated-background">
    </div>
  </div>
)

export default LoadingBook;